import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import INDEX from './pages/INDEX'
import LMP from './pages/LMP'
import SONO from './pages/SONO'

function App() {
	return (
		<div className="App">
		<Router>
			<Routes>
				<Route path="/about" element={<Navigate to="/about.html" replace={true} />} />
				<Route path="/lmp" element={<LMP/>} />
				<Route path="/sono" element={<SONO/>} />
				<Route path="/" element={<INDEX/>} />
			</Routes>
		</Router>
		</div>
	);
}

export default App;
